module.exports = __webpack_public_path__ + "img/Calls.cc72c4dd.png";